import { LocationModel } from './types';

export const EmptyLocation = (): LocationModel => ({
  city: '',
  country: '',
  countryComments: '',
  countryFocused: false,
  county: '',
  layout: '',
  state: '',
  street: '',
  street2: '',
  validated: false,
  zipcode: '',
});

export const EmptyLocationInstance = EmptyLocation();

/**
 * A lot of the components default to United States. Due to this, certain
 * validators look for "United States" in order validate.
 */
export const EmptyUSLocation = (): LocationModel => ({
  city: '',
  country: 'United States',
  countryComments: '',
  countryFocused: false,
  county: '',
  layout: '',
  state: '',
  street: '',
  street2: '',
  validated: false,
  zipcode: '',
});

export const EmptyUSLocationInstance = EmptyUSLocation();
